import React, { useEffect, useContext, Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { EntryContext } from '../contexts/entryContext';
import InnerLayout from '../components/layouts/InnerLayout';
import GameHowToPlay from '../components/GameHowToPlay';

const GameDetail = () => {
    const navigate = useNavigate();
    const { revealGames, siteAssets } = useContext(EntryContext);

    const params = useParams();
    let gameName = params.game;

    useEffect(() => {
        if (!revealGames || revealGames.length === 0 || !gameName) {
            return navigate('/', { replace: true });
        }
    }, [revealGames, gameName, navigate]);

    const [gameDetail] = revealGames?.filter((game) => game.name.toLowerCase() === gameName.toLowerCase()) ?? [];

    return (
        gameDetail && (
            <Fragment>
                <InnerLayout pageClass={`game-detail-page`}>
                    <Helmet>
                        <title>
                            {siteAssets?.howToPlayPageTitle ?? 'How To Play'}: {gameDetail?.title} - {siteAssets?.title ?? 'Scratch Connect'}
                        </title>
                    </Helmet>

                    <GameHowToPlay gameDetail={gameDetail} />
                </InnerLayout>
            </Fragment>
        )
    );
};

export default GameDetail;
